import { Directive, ElementRef, Input } from '@angular/core';
import { AuthorizationService } from '../services/authorization.service';
import { AuthGroup } from 'src/app/shared/models/userType.model';
import { faDiceD20 } from '@fortawesome/free-solid-svg-icons';

@Directive({
  selector: '[HideIfUnAuthorized]',
  standalone: false
})
export class HideIfUnAuthorizedDirective {

  @Input('HideIfUnAuthorized') permission: AuthGroup; // Required permission passed in
  @Input() GroupId: string; // Required permission passed in

  constructor(private el: ElementRef, private authorizationService: AuthorizationService) {

  }

  ngOnInit() {


    if (this.GroupId == undefined || this.GroupId == null) {
      this.GroupId = "-1";

    }
    if (!this.authorizationService.hasRequiredPermission(this.permission, this.GroupId, this.el.nativeElement)) {

      this.el.nativeElement.style.display = 'none';
    }
    else {

    }
  }


}
